import { Backdrop, Button, TextField, ThemeProvider } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import { createTheme } from "@mui/material/styles";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../components/Loader";
import sha512 from "crypto-js/sha512";
import { xCheckSumIdGernator } from "../../helper/helper";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

export default function AccountStatus() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });
  const [open, setOpen] = useState(false);
  const [interval, setInterval] = useState(false);
  const [otp, setOtp] = useState("");
  const [access, setAccess] = useState("");
  const [submitDiv, setSubmitDiv] = useState(false);
  const [file, setFile] = useState([]);
  const [fileURL, setFileURL] = useState(null);
  const inputRef = useRef(null);

  const [filename, setFilename] = useState("Choose File");
  const [uploadedFile, setUploadedFile] = useState({});
  const [message, setMessage] = useState("");
  const [AdhaarCard, setAdhaarCard] = useState(undefined);
  const [PanCard, setPanCard] = useState("");
  const [documents, setDocuments] = useState("");
  const [first, setfirst] = useState(false);
  const [first1, setfirst1] = useState("");
  const [first2, setfirst2] = useState("");
  const [counter, setCounter] = useState(59);

  React.useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const resetFileInput = () => {
    inputRef.current.value = null;
  };

  const tempuser = localStorage.getItem("status");
  const emailstatus = localStorage.getItem("emailverification");
  const cpId = localStorage.getItem("userId");
  const tokken = localStorage.getItem("tokemtemp");

  const seTrue1 = () => {
    setfirst(true);
  };

  const fetchDocuments = async () => {
    try {
      setOpen(true);
      const res = await axios(
        `http://192.168.167.66:5001/admin/v1/fetch/document/type`,
        {
          headers: {
            Authorization: `Bearer ${tokken}`,
            userId: cpId,
            source: "web",
          },
        }
      );
      // console.log(res.data);
      setDocuments(res.data.cmsDocTypeList);
      const status = res.data.statusDescription.statusCode;
      if (status == 200) {
        setOpen(false);
      } else {
        setOpen(false);
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);
    }
  };
  // console.log(documents);
  useEffect(() => {
    fetchDocuments();
  }, []);

  const handleChange = (event) => {
    // console.log({ event });
    // setFile({ [e.target.files[0]]: URL.createObjectURL(file) });
    setFile(event.target.files[0]);
  };

  const fileSubmit = async (e, index) => {
    // e.preventDefault();
    // console.log(index.documentType);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("cpId", cpId);
    formData.append("docType", index.documentType);

    try {
      setOpen(true);
      // console.log(`Bearer ${tokken}`);
      const res = await axios.post(
        "http://192.168.167.66:5001/admin/v1/document/upload",
        formData,
        {
          headers: {
            Authorization: `Bearer ${tokken}`,
            userId: cpId,
            source: "web",
          },
        }
      );
      // console.log(res.data, "fuileupload data");

      const status = res.data.statusDescription.statusCode;
      if (status === 200) {
        setOpen(false);
        setTimeout(async () => {
          Swal.fire({
            icon: "success",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      } else {
        setOpen(false);
        setTimeout(async () => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }

      setMessage("File Uploaded");
    } catch (err) {
      // console.log(err);
      setTimeout(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }, 100);
    }
  };

  const parseData = localStorage.getItem("status");

  const customId1 = "custom-id-yess";
  const validationSchema = yup.object({
    otp: yup
      .number("Enter OTP")

      .max(10000000000)
      .min(100, "OTP should be of minimum 2 characters length"),
  });

  const parseDataa = JSON.parse(parseData);

  // console.log(parseDataa.username, "hello");
  // console.log(parseDataa.mobileNo, "hello");

  const resendOtp = async () => {
    try {
      setOpen(true);
      const generator = Math.floor(Math.random() * 100000000);
      const allValues = `${parseDataa.mobileNo}${generator}54IzSRi`;
      const allValuesHashed = sha512(allValues).toString();
      const res = await axios.post(
        "http://192.168.167.66:5001/auth/v1/pin/generate",

        {
          msisdn: Number(parseDataa.mobileNo),
          requestId: generator,
          isDebug: false,
        },
        {
          headers: {
            "X-CHECKSUM-ID": allValuesHashed,
          },
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        localStorage.setItem("transactionId", res.data.transactionId);
        localStorage.setItem("msisdn", res.data.msisdn);
        await toast.success("Otp Sent Successfully", {
          theme: "colored",
          customId1,
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
          customId1,
        });
      }
      // console.log(res.data);
    } catch (error) {
      // console.log(error);
      setOpen(false);
      await toast.error("Something Went Wrong", {
        theme: "colored",
        customId1,
      });
    }
  };
  const verifyEmail = async (e) => {
    e.preventDefault();
    try {
      setOpen(true);
      const xCheckSumValues = xCheckSumIdGernator();
      // console.log(xCheckSumValues, "to srtring");
      const res = await axios(
        `http://192.168.167.66:5001/auth/v1/email/verification/${localStorage.getItem(
          "tokemtemp"
        )}`
      );

      if (res.data.statusDescription.statusCode == 200) {
        await toast.success(res.data.statusDescription.description, {
          theme: "colored",
        });
        setOpen(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    try {
      const generator = Math.floor(Math.random() * 100000000);
      const allValues = `${localStorage.getItem(
        "transactionId"
      )}${generator}54IzSRi`;
      const allValuesHashed = sha512(allValues).toString();

      setOpen(true);
      const res = await axios.post(
        `http://192.168.167.66:5001/auth/v1/pin/verify`,
        {
          msisdn: `${localStorage.getItem("msisdn")}`,
          otp: "1234",
          transactionId: `${localStorage.getItem("transactionId")}`,
          requestId: generator,
          isDebug: false,
        },
        {
          headers: {
            "X-CHECKSUM-ID": allValuesHashed,
          },
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        await toast.success("Otp Verified SuccessFully", {
          theme: "colored",
        });
        setSubmitDiv(true);
        setOpen(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
    }
  };

  const modelButtonApprove = useRef(null);
  const alreaddyOtpButtonModel = async () => {
    await modelButtonApprove.current.click();
  };

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>
        <ThemeProvider theme={theme}>
          <ToastContainer autclose={100} />
          <div>
            <button
              ref={modelButtonApprove}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Enter Your OTP Here!
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="col-md-3 px-0">
                    <input
                      required
                      className="w-100 form-control p-2"
                      style={{ border: "1px solid #2191d0" }}
                      placeholder="Enter OTP Here"
                      type="string"
                      min="4"
                      max="6"
                      onChange={(e) => {
                        setOtp(e.target.value);
                      }}
                    />
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={verifyOtp}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="container-fluid pt-5"
            style={{ marginTop: "8needs-validation0px" }}
          >
            <div className="card">
              <div className="card-header p-3 pt-2">
                <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                  <i className="material-icons opacity-10">person</i>
                </div>
                <div className="pt-1 d-flex justify-content-between align-items-center">
                  <p
                    className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                    style={{ marginLeft: "70px" }}
                  >
                    Account Status
                  </p>
                  <Link to="/" className="d-block">
                    <button
                      style={{ marginLeft: "1127px" }}
                      type="button"
                      className="btn btn-primary align-right m-0"
                      onClick={() => {
                        localStorage.clear();
                      }}
                    >
                      Log Out
                    </button>
                  </Link>
                </div>
              </div>
              <div className="card-body">
                {/* {submitDiv == false ? (
                  <div className="card shadow-none border bg_blue">
                    <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                      Please Verify Your Phone Number..
                    </span>
                    {first == true ? (
                      <div className="card-body text-lg-start text-center">
                        <div className="text-center">
                          <form onSubmit={verifyOtp} className="row">
                            <p>
                              Your Phone Number status is Pending !! Please Wait
                              for Approval!!
                            </p>
                            <div className="input-group input-group-outline mb-4">
                              <div className="col-md-3 mx-auto">
                                <input
                                  required
                                  className="w-100 form-control"
                                  style={{ border: "1px solid #2191d0" }}
                                  placeholder="Enter OTP Here"
                                  type="string"
                                  min="4"
                                  max="6"
                                  onChange={(e) => {
                                    setOtp(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="d-flex justify-content-center">
                              <button
                                className="btn bg-gradient-primary m-0"
                                type="submit"
                              >
                                Submit
                              </button>

                              <button
                                className="btn bg-gradient-primary m-0 ms-2"
                                type="button"
                                onClick={resendOtp}
                              >
                                Resend Otp in : {counter}
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    ) : (
                      <button
                        className="btn bg-gradient-primary mx-auto my-5"
                        type="submit"
                        onClick={() => {
                          seTrue1();
                          resendOtp();
                        }}
                      >
                        Send OTP
                      </button>
                    )}
                  </div>
                ) : (
                  <h2 className="flex">Your Phone Number Has been Verified</h2>
                )} */}
                <div className="card-body">
                  <div className="card shadow-none border bg_blue">
                    <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                      Please Verify Your Phone Number..
                    </span>
                    {submitDiv == false ? (
                      <form onSubmit={verifyOtp}>
                        <div className="card-body">
                          {first ? (
                            <>
                              <div className="row d_flex justify-content-between align-items-center mx-0">
                                <div className="col-md-3 px-0">
                                  <span className="d-block spn text-capitalize">
                                    phone number:
                                  </span>
                                  <h5 className="d-block spn_1 text-capitalize ms-4">
                                    {
                                      JSON.parse(localStorage.getItem("status"))
                                        .mobileNo
                                    }
                                  </h5>
                                </div>

                                <div className="col-md-3 px-0">
                                  <span className="d-block spn text-capitalize">
                                    status:
                                  </span>
                                  <span className="d-block spn_1 text-capitalize ms-4">
                                    {parseDataa.otpVerification ? (
                                      <span class="badge badge-success">
                                        Approved
                                      </span>
                                    ) : (
                                      <span class="badge badge-danger">
                                        Pending
                                      </span>
                                    )}
                                  </span>
                                </div>

                                {/* <div className="input-group input-group-outline mb-4"> */}
                                <div className="col-md-3 px-0">
                                  <input
                                    required
                                    className="w-100 form-control p-2"
                                    style={{ border: "1px solid #2191d0" }}
                                    placeholder="Enter OTP Here"
                                    type="string"
                                    min="4"
                                    max="6"
                                    onChange={(e) => {
                                      setOtp(e.target.value);
                                    }}
                                  />
                                </div>
                                {/* </div> */}
                              </div>

                              <div className="d-flex justify-content-end mt-4">
                                <button
                                  className="btn bg-gradient-primary m-0"
                                  type="submit"
                                >
                                  Submit
                                </button>
                                <button
                                  className="btn bg-gradient-primary m-0 ms-2"
                                  type="button"
                                  onClick={resendOtp}
                                >
                                  Resend Otp in : {counter}
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="row d_flex justify-content-between align-items-center">
                                <div className="col-md-6">
                                  {/* <div className="d-inline-block"> */}
                                  <span className="d-block spn text-capitalize">
                                    phone number:
                                  </span>
                                  <span className="d-block spn_1 text-capitalize m-0 mt-2">
                                    <h5 className="d-block spn_1 text-capitalize">
                                      {
                                        JSON.parse(
                                          localStorage.getItem("status")
                                        ).mobileNo
                                      }
                                    </h5>
                                  </span>
                                  {/* </div> */}
                                </div>

                                <div className="col-md-6">
                                  <span className="d-block spn text-capitalize">
                                    status:
                                  </span>
                                  <div className="d-flex mt-2">
                                    {/* <span className="d-block spn_1 text-capitalize ms-4">
                                      {parseDataa.otpVerification
                                        ? "Approved"
                                        : "Pending"}
                                    </span> */}
                                    <span class="badge badge-danger">
                                      pending
                                    </span>
                                    <span class="badge badge-warning">
                                      Warning
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex justify-content-end mt-4">
                                <button
                                  className="btn bg-gradient-primary m-0 ms-2"
                                  type="submit"
                                  onClick={() => {
                                    seTrue1();
                                    resendOtp();
                                  }}
                                >
                                  Send OTP
                                </button>
                              </div>
                              <div className="d-flex justify-content-end mt-4">
                                <button
                                  className="btn bg-gradient-primary m-0 ms-2"
                                  type="button"
                                  onClick={() => {
                                    alreaddyOtpButtonModel();
                                  }}
                                >
                                  Already Have an OTP?
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </form>
                    ) : (
                      <h2 className="flex">
                        Your Phone Number Has been Verified
                      </h2>
                    )}
                  </div>
                </div>
                <div className="card shadow-none border bg_blue mt-5">
                  <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                    Email Status
                  </span>

                  <div className="card-body text-lg-start text-center">
                    <form className="row">
                      <div className="font-weight-bold d-flex justify-content-center">
                        <h5 className="m-0">
                          Your Email-id is: {parseDataa.email}
                        </h5>

                        <h5 className="m-0 mx_4">
                          Status for Your Email Verification is:{" "}
                          {parseDataa.emailVerification ? (
                            <span class="badge badge-success">Approved</span>
                          ) : (
                            <span class="badge badge-danger">Pending</span>
                          )}
                        </h5>
                        <h5 className="m-0">
                          {" "}
                          Want to Confirm Your Email Verification Click Here!!
                        </h5>
                      </div>
                      {/* <div className="fw-bolder text-center">
                        <h5>
                          Status for Your Email Verification is:{" "}
                          {parseDataa.emailVerification
                            ? "Approved"
                            : "Pending"}
                        </h5>
                      </div> */}
                      {/* <div className="fw-bolder d-flex justify-content-end ">
                        <h5>
                          {" "}
                          Want to Confirm Your Email Verification Click Here!!
                        </h5>
                      </div> */}
                      <div className="d-flex justify-content-end ">
                        <button
                          className="btn bg-gradient-primary  my-4 mb-2"
                          style={{
                            alignItems: "end",
                          }}
                          type="button"
                          onClick={verifyEmail}
                        >
                          Send Email
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="card-body">
                <div className="card shadow-none border bg_blue">
                  <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                    Documents Status
                  </span>
                  {documents &&
                    documents.map((e, index) => {
                      return (
                        <div className="card-body text-lg-start text-center">
                          <form
                            onSubmit={(ev) => {
                              fileSubmit(ev, e);
                            }}
                          >
                            <div className="row align-items-end">
                              <div className="col-md-6">
                                <p>{e.documentType}</p>
                                <Button
                                  className="btn btn-primary"
                                  variant="contained"
                                  component="label"
                                >
                                  <input
                                    required
                                    accept="image/*"
                                    type="file"
                                    style={{ color: "#fffff" }}
                                    onChange={handleChange}
                                  />
                                </Button>
                              </div>
                              <div className="col-md-6 d-flex justify-content-end">
                                {/* <p>Mandatory:{e.mandatory}</p> */}
                                <button
                                  type="submit"
                                  className="btn btn_primary m-0"
                                  style={{ padding: "0.6rem 1.5rem" }}
                                >
                                  Submit File
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </main>
    </>
  );
}
